
export default {
  name: "Nav",
  data(): {
    primary_links: Array<{ href: string; name: string }>;
    secondary_links: Array<{ href: string; name: string }>;
  } {
    return {
      primary_links: [
        { href: "/", name: "Home" },
        { href: "/blog/", name: "Blog" },
        { href: "/projects/", name: "Projects" },
      ],
      secondary_links: [
        { href: "/vsrgs/", name: "Rhythm Games (WIP)" },
        { href: "/programming/", name: "Programming (WIP)" },
        { href: "/art/", name: "Art (WIP)" },
        { href: "/about/", name: "About (WIP)" },
        // { href: "/contact/", name: "Contact (Under Construction)" },
        { href: "/release/", name: "express" },
      ],
    };
  },
};
